//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import * as d3 from "d3";
import d3Locale from "d3-format/locale/en-US.json";
import { csvGenerator } from "@/utils/csvGenerator.js";


const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

function formatNumber(num) {
  if (num !== null && num.toString().includes(".")) {
    return d3.format(",.2f")(num);
  } else {
    return d3.format(",")(num);
  }
}

export default {
  name: "GraphTable",
  props: ["tableClass", "data", "context"],
  components: {
    Table,
  },
  mounted: function () {
    d3Locale.thousands = " "
    d3Locale.nan = "N/A"
    d3.formatDefaultLocale(d3Locale);
  },
  data: () => ({
    separator: "horizontal",
    recordsTotal: 0,
    tableData: [],
    columns: [],
  }),
  methods: {
    exportData: function () {
      let exportContent = [];
      exportContent.push(this.columns.map(e => e.label))
      let data = this.tableData.map(e => Object.values(e))
      exportContent = exportContent.concat(data)

      csvGenerator.toCSV('tableExport.csv', exportContent);
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function () {
        this.tableData = [];
        this.recordsTotal = this.data.mainData.length;

        this.columns = [
          {
            name: "label",
            required: false,
            label: this.context,
            align: "left",
            field: (row) => (row.label ? row.label : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: "value",
            required: false,
            label: "Valor",
            align: "left",
            field: (row) => (row.value ? row.value : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: "percentage",
            required: false,
            label: "Percentagem",
            align: "left",
            field: (row) => (row.percentage ? row.percentage : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
          {
            name: "acumulated_percentage",
            required: false,
            label: "% acumulada",
            align: "left",
            field: (row) => (row.accumulatedPercent ? row.accumulatedPercent : "N/A"),
            format: DEFAULT_FORMAT,
            sortable: false,
          },
        ];

        let accumulated = 0;
        for (let i = 0; i < this.data.mainData.length; i++) {
          this.tableData.push({
            label: this.data.mainData[i].label,
            value: formatNumber(this.data.mainData[i].value),
            percentage: formatNumber(this.data.mainData[i].abc_curve - accumulated),
            accumulatedPercent: formatNumber(this.data.mainData[i].abc_curve)
          })
          accumulated = this.data.mainData[i].abc_curve
        }

        // this.columns.push({
        //   name: "Variation",
        //   required: false,
        //   label: "Variação",
        //   align: "left",
        //   field: (row) => (row.variation ? row.variation : "N/A"),
        //   format: DEFAULT_FORMAT,
        //   sortable: false,
        // })
      },
    },
  }
};
